import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getAccountStatusNotice,
  saveAccountStatusNotice,
} from "../../../utils/accountStatus";

const rawBaseQuery = fetchBaseQuery({
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryWithBaseUrl = async (args, api, extraOptions) => {
  let modifiedArgs = args;

  if (typeof args === "object" && args.baseUrl) {
    const { baseUrl, ...restArgs } = args;
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const cleanUrl = restArgs.url.startsWith('/') ? restArgs.url : `/${restArgs.url}`;
    modifiedArgs = { ...restArgs, url: cleanBaseUrl + cleanUrl };
  }

  // Perform the API call
  const result = await rawBaseQuery(modifiedArgs, api, extraOptions);

  const path = window.location.pathname;

  if (path !== "/auth/sign-in" && path !== "/auth/signup/password") {
    // Suspended / removed / deleted account — keep the reason for the sign-in popup
    const accountNotice = getAccountStatusNotice(result?.error?.data);
    if (accountNotice) {
      saveAccountStatusNotice(accountNotice);
    }

    // 🚨 If 401 Unauthorized (or inactive account), handle redirect
    if (result?.error?.status === 401 || accountNotice) {
      // Clear auth storage
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");

      // Avoid redirection loop
      if (window.location.pathname !== "/auth/sign-in") {
        window.location.href = "/auth/sign-in";
      }

      return {
        error: {
          status: result.error.status,
          data: "Session expired. Redirecting to login...",
        },
      };
    }
  }

  return result;
};
